import React, { Component } from "react";
import { Link } from "react-router-dom";

// import Loader
import Loader from "./Loader";

class DashboardOutstandingFeesLoader extends Component {
  render() {
    return (
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6">
        {/* card for outstanding fees */}
        <div className="card">
          <div className="card-header">
            <div className="row no-gutters">
              <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                Oustanding Fee(s)
              </div>
              <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 text-right">
                <Link to="/fees" className="card-link">
                  Fees <i className="fa fa-angle-right" />
                </Link>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="dashboard-transaction-container">
              <div className="details">
                <div className="big-amount-text">
                  <Loader width="350" height="30" />
                </div>
                <div className="fee-description">
                  <Loader width="250" height="20" />
                </div>
              </div>
              <div className="button-action-container">
                <div className="row no-gutters">
                  <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <Loader width="150" height="50" />
                  </div>
                  <div className="days-remaining col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <i>
                      {/* <img
                                    src={daysRemainingIcon}
                                    className="svg days-remaining"
                                    alt="Academic Details"
                                  /> */}
                    </i>
                    <Loader width="200" height="20" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* card for outstanding fees */}
      </div>
    );
  }
}

export default DashboardOutstandingFeesLoader;
